/*
NAME: WorksChartTiming
DESC: Comnponenete será responsavél por receber os trabalhos e realizar o processamento do array 
ordanando os trabalhos por data que foram sincronizadas no servidor 
props:
-items Array de trabalhos
- - - - Default
- style: Object, style object to overwrite this component style
NOTES:

*/
import React, {useState, useEffect} from 'react';
import ChartPeriod from '../basic/ChartPeriod'
import values from '../../values/values'
import ChartPeriodDataBinder from '../../usecases/ChartPeriodDataBinder';
import strings from '../../values/strings/strings';

function WorksChartPeriodSinc({style, items}) {
   const [chartValues, setChartValues] = useState([]);  
   const [itemsSorted, setitemsSorted] = useState([]) 

   let limit = 10;

  
   useEffect(() => {    
   
      if(items && items.length > 0){
         //Separar os sincronismos dos trabalhos em um array proprio
         let sinc = items.map(item => {
            return item.sincronismo
         })      
         let sorted = [...sinc]
         setitemsSorted(sorted)
         bindData(sorted, values.TIME_FILTERS[0])    
   }
   }, [items])

    
   const bindData =  (items, filter,) => {
      ChartPeriodDataBinder('data_cad_server', items, filter, limit).then(res => {
         setChartValues(res)
      })      
   }     

   return (
      <div style={{...style}}>
         
        <ChartPeriod 
            title={strings.getString('screen_chart_sinc_period')}
            limit={limit}
            items={chartValues}
            onFilterChange={(filter) => bindData(itemsSorted,filter)}
            width={800}                 
         />   
      </div>
   );
}
export default WorksChartPeriodSinc;